import { CommonModule } from '@angular/common';
import { Component, Injectable } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderService } from '../../loader/loader.service';

@Component({
  selector: 'app-preloader',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './preloader.component.html',
  styleUrl: './preloader.component.scss'
})

@Injectable({
  providedIn: 'root'
})
export class PreloaderComponent {
  isLoading = false;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.loaderService.isLoading.subscribe(
      (loading) => this.isLoading = loading
    );
  }
}
